import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/estoque/setores/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findSetor({ empresa_cnpj, per_page = 1000 }) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${
      per_page && `&per_page=${per_page}`
    }`,
    "GET",
    headers
  );
}
